var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.params.data
    ? _c(
        "div",
        { attrs: { align: "center" } },
        [
          _c("buttonComponent", {
            attrs: {
              icon: _vm.params.icon,
              action: _vm.params.action,
              title: _vm.params.title,
              actionParams: _vm.params.data,
              btnClass: _vm.params.btnClass
            }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }